"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _gridItem = _interopRequireDefault(require("./grid-item"));

var _jsxRuntime = require("react/jsx-runtime");

const Grid = ({
  children,
  css,
  ...props
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_gridItem.default, {
    css: { ...css
    },
    ...props,
    children: children
  });
};

var _default = Grid;
exports.default = _default;
module.exports = exports.default;